import React from "react";
import Loading from "react-fullscreen-loading";

export const Spinner = () => {
  return <Loading loading background="#1b50a314" loaderColor="#1b50a3d1" />;
};
